import environment from 'environment';
import makeRequest from 'api/makeRequest';
import { handleError } from 'services/ErrorService/ErrorService';

const { GLADLY_BASE_URL } = environment.eCommerce;

export const getBookIssuesOrders = async (simplrAccountId, customerEmail) => {
  const url = `${GLADLY_BASE_URL}/bookIssues`;
  const params = { simplrAccountId, customerEmail };
  try {
    const response = await makeRequest(url, { params });

    return response.orders;
  } catch (error) {
    handleError({
      error,
      customMessage: 'Something went wrong while grabbing the book issues orders',
      showPopup: true,
    });
  }
};

export const fileBookIssues = async (simplrAccountId, customerEmail, order) => {
  const url = `${GLADLY_BASE_URL}/bookIssues`;
  const data = { simplrAccountId, customerEmail, order };
  try {
    await makeRequest(url, { method: 'post', data });
  } catch (error) {
    handleError({ error, customMessage: 'Something went wrong while processing the book issue', showPopup: true });
  }
};
